import { AppSettings } from './app.settings';
export class CitySettings {
    public static CITY_DETAILS = `${AppSettings.BASE_URL}/api/location/:id`;
    public static CITY_HREFS = `${AppSettings.BASE_URL}/api/location/href/:id`;    
    public static CITY_ABOUT = `${AppSettings.BASE_URL}/api/location/about/:id`;
    public static CITY_USEFUL = `${AppSettings.BASE_URL}/api/location/useful/:id`;
    public static CITY_PRODUCTS = `${AppSettings.BASE_URL}/api/products/city/:id`;
    public static CITY_PRODUCTS_TOP = `${AppSettings.BASE_URL}/api/products/city/:id/top`;
}